export const performancereview_Spanish= 
{
  "id": 0,
  "name": "Revisión de desempeño",
  "prompts": [
    {
      "id": 1,
      "who": "Tarea",
      "what": "Escribir una revisión de desempeño."
    },
    {
      "id": 2,
      "who": "Nombre",
      "what": "Eric"
    },
    {
      "id": 3,
      "who": "Cargo",
      "what": "Desarrollador de software junior"
    },
    {
      "id": 4,
      "who": "Plazos",
      "what": "Los cumple con mucha frecuencia. Su código no tiene errores."
    },
    {
      "id": 5,
      "who": "Miembro del equipo",
      "what": "Participa bien."
    }
  ]
}


    export const inventory_Spanish = 
    {
      "id": 0,
      "name": "Cálculo",
      "prompts": [
        {
          "id": 1,
          "who": "Cantidad requerida:",
          "what": `bolsas de café: 100\nbolsas de té: 30\nhuevos: 3 docenas\nleche: 5 galones`
        },
        {
          "id": 2,
          "who": "Cantidad utilizada:",
          "what": `bolsas de café: 20\nleche: 2 galones\nhuevos: 1 docena\nté: 2 bolsas`
        },
        {
          "id": 3,
          "who": "Tarea:",
          "what": `¿Qué se necesita pedir para reabastecer todos los artículos?\nPresentar los datos en formato CSV y en forma tabular.`
        },
      ]
    }




export const emailproperty_Spanish = 
{
  "id": 0,
  "name": "Correo electrónico",
  "prompts": [
    {
      "id": 1,
      "who": "Tarea",
      "what": "Escribe un correo electrónico sobre esta propiedad."
    },
    {
      "id": 2,
      "who": "Propiedad",
      "what": "Casa de dos pisos"
    },
    {
      "id": 3,
      "who": "Habitaciones",
      "what": "4"
    },
    {
      "id": 4,
      "who": "Baños",
      "what": "3.5"
    },
    {
      "id": 5,
      "who": "Condición",
      "what": "actualización reciente"
    },
    {
      "id": 6,
      "who": "Ciudad",
      "what": "Evanston"
    },
    {
      "id": 7,
      "who": "Escuelas",
      "what": "Escuelas primarias y de segundo grado de alto rango"
    },
    {
      "id": 8,
      "who": "Restaurantes",
      "what": "Muchas opciones de restaurantes elegantes"
    },
    {
      "id": 9,
      "who": "Para:",
      "what": "John"
    },
    {
      "id": 10,
      "who": "De:",
      "what": "Marry"
    }

  ]
}

export const extraction_Spanish=
{
  "id":0,
  "name": "Agrupar productos",
  "prompts":[
      {
          "id":1,
          "who":"Productos:",
          "what":"Las naranjas crecen en California y Florida. Los principales productores de tomate se encuentran en Florida, las manzanas son un producto importante para el estado de Michigan. Texas es el principal productor de carne de res y Wisconsin de queso."
      },
      {
          "id":2,
          "who":"Tarea:",
          "what":"Agrupa los siguientes productos por región."
      },
      {
          "id":3,
          "who":"Tarea:",
          "what":"Agrupa las regiones por productos."
      }
  ]
}


    export const productdescription_Spanish =
    {
      "id":0,
      "name": "Brown bag",
      "prompts":[
          {
              "id":1,
              "who":"Tarea:",
              "what":"Describe el siguiente producto:"
          },
          {
              "id":2,
              "who":"Qué:",
              "what":"Bolso de cuero"
          },
          {
              "id":3,
              "who":"Color:",
              "what":"marrón"
          },
          {
              "id":4,
              "who":"Estilo:",
              "what":"estilo de negocios"
          },
          {
              "id":5,
              "who":"Precio:",
              "what":"$79"
          },

      ]
  }

    export const problemsolving_Spanish=
    {
      "id":0,
      "name": "Tom y Peter",
      "prompts":[
          {
              "id":1,
              "who":"Quién",
              "what":"Tom y Peter"
          },
          {
              "id":2,
              "who":"Ubicación",
              "what":"Tom está en la ciudad A, Peter está en la ciudad B."
          },
          {
              "id":3,
              "who":"Distancia",
              "what":"La distancia entre la ciudad A y la ciudad B es de 15 millas."
          },
          {
              "id":4,
              "who":"Velocidad de caminata",
              "what":`Tom camina a 2 mi/h
              \nPeter camina a 3 mi/h`
          },
          {
              "id":5,
              "who":"Tarea",
              "what":"Si Tom y Peter comienzan a caminar hacia el otro al mismo tiempo, ¿cuánto tiempo tomará antes de que se encuentren?"
          },
      ]
  }

    
    export const floridaoranges_Spanish= 
    {
      "id": 0,
      "name": "Naranjas de Florida",
      "prompts": [
        {
          "id": 1,
          "who": "Informe trimestral: Producción de naranjas en Florida",
          "what": "Trimestre: enero - marzo"
        },
        {
          "id": 2,
          "who": "1. Resumen: ",
          "what": "producción total, condiciones climáticas, desafíos enfrentados y proyecciones futuras para la industria de naranjas en el estado"
        },
        {
          "id": 3,
          "who": "2. Producción total de naranjas",
          "what": "Total de 2.5 millones de cajas. Aumento del 10% en la producción en comparación con el mismo período del año pasado."
        },
        {
          "id": 4,
          "who": "3. Condiciones climáticas: ",
          "what": "Temperaturas moderadas, con lluvias adecuadas. Se observaron frentes fríos y eventos de heladas ocasionales."
        },
        {
          "id": 5,
          "who": "4. Desafíos enfrentados: ",
          "what": "Amenaza continua de enfermedades cítricas, especialmente el enverdecimiento de los cítricos. Escasez de mano de obra. Aumento del costo de producción."
        },
        {
          "id": 6,
          "who": "5. Demanda del mercado y exportaciones: ",
          "what": "Interés estable durante el primer trimestre tanto a nivel nacional como internacional. Aumento de las ventas: Europa, Canadá."
        },
        {
          "id": 7,
          "who": "6. Proyecciones futuras: ",
          "what": "Se espera que la producción se mantenga estable. Implementación de estrategias de manejo de enfermedades. Vigilancia cercana del clima."
        },
        {
          "id": 8,
          "who": "7. Conclusión: ",
          "what": "Escribir un informe basado en los hechos mencionados anteriormente. Utilizar los mismos encabezados."
        }
  
      ]
    }

    export const email_Spanish= 
    {
      "id": 0,
      "name": "Email",
      "prompts": [
        {
          "id": 1,
          "who": "Para quién:",
          "what": "John Smith"
        },
        {
          "id": 2,
          "who": "Asunto: Conferencia de paneles solares",
          "what": "Planeando un viaje a Hawái para la conferencia anual de paneles solares."
        },
        {
          "id": 3,
          "who": "Fecha:",
          "what": "25-29 de septiembre"
        },
        {
          "id": 4,
          "who": "Saludos:",
          "what": "Mike Thomson"
        },
        {
          "id": 5,
          "who": "Tarea:",
          "what": "Escribir un correo electrónico."
        }
      ]
    }
    
    

    export const travelexpense_Spanish= 
    {
      "id": 0,
      "name": "Gasto de viaje",
      "prompts": [
        {
          "id": 1,
          "who": "Título:",
          "what": "Mostrar esto como encabezado: Viaje a Nueva York - gasto de viaje"
        },
        {
          "id": 2,
          "who": "Transporte:",
          "what": "Tarifa aérea: $560.\nGastos de taxi: $156"
        },
        {
          "id": 3,
          "who": "Alojamiento:",
          "what": "Hotel - 2 noches: $350"
        },
        {
          "id": 4,
          "who": "Comidas:",
          "what": "Desayuno: $56\nAlmuerzo: $78\nCena: $126\nSnacks: $13"
        },
        {
          "id": 5,
          "who": "Tarea:",
          "what": "Listar todos los gastos en una línea separada.\nAl final, mostrar el total."
        }
      ]
    }